// Shared flags so only the first matching error across all axios instances
// dispatches a global event. Multiple in-flight requests can fail at once;
// we only want one notification / redirect.

let _sessionReplacedFired = false
let _adminIpDeniedFired = false

export function tryFireSessionReplaced() {
    if (_sessionReplacedFired) return false
    _sessionReplacedFired = true
    return true
}

export function tryFireAdminIpDenied() {
    if (_adminIpDeniedFired) return false
    _adminIpDeniedFired = true
    return true
}

/** Allow a fresh fire after the user reconnects / logs in again. */
export function resetAdminIpDeniedGuard() {
    _adminIpDeniedFired = false
}
